import { Filter } from '@cubejs-client/core';

// Target member used to rewrite an HCP-led country filter (DEFAULT_COUNTRY_MEMBER)
// when a query touches a cube that has no join path to hcp. Such a cube cannot
// resolve hcp.country_code, so the filter must be redirected to the cube's own
// country_code dimension. Cubes that CAN reach hcp are intentionally absent here:
// keeping hcp.country_code lets Cube join through to hcp so the selection filters
// by the HCP's country.
//
// hco is deliberately NOT listed. It joins hcp via hco -> hcp_hco -> hcp, so an
// HCP-led selection stays hcp.country_code and Cube filters the HCO list by the
// HCP's country, pruning orphan HCOs (no matching HCP in the selected country).
// Rewriting it to hco.country_code (or the RLS column hcp_hco.hcp_hco_country_code,
// which tracks the HCO's own country) returned every HCO in the country and made
// the HCP tab produce the same result as the HCO tab (work item #4070). The HCO
// tab sends hco.country_code directly, which is never DEFAULT_COUNTRY_MEMBER and so
// is never rewritten, so the two tabs now produce distinct queries.
export const CUBES_WITH_OWN_COUNTRY_CODE: Readonly<Record<string, string>> = {
  hcos_all_locations: 'hcos_all_locations.country_code',
  hco_account_plan: 'hco_account_plan.country_code',
  hcp_territory: 'hcp_territory.country_code',
  partnerscore: 'partnerscore.country_code',
  competitor_partner_score: 'competitor_partner_score.country_code',
  personify_hcp_recommendation_hist: 'personify_hcp_recommendation_hist.country_cd',
  hco_hierarchy: 'hco.country_code',
  insight: 'insight.country_code',
};

export const VIEW_COUNTRY_CODE_OVERRIDES: Readonly<Record<string, string>> = {
  hcp_view: 'hcp_view.country_code',
};

export const DEFAULT_COUNTRY_MEMBER = 'hcp.country_code';

export const SECURITY_BYPASS_FILTER: Filter = {
  member: DEFAULT_COUNTRY_MEMBER,
  operator: 'equals',
  values: ['__ALL__'],
};

export function getCountryDimensionForCube(cubeName: string): string {
  return VIEW_COUNTRY_CODE_OVERRIDES[cubeName] ?? CUBES_WITH_OWN_COUNTRY_CODE[cubeName] ?? DEFAULT_COUNTRY_MEMBER;
}
